import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { ERROR, LOCALE, FLOW_TYPE, COUNTRY, ACTOR } from '../../framework/App/AppConstants';
import RedirectButton from '../RedirectButton/RedirectButton';
import Col from '../VXGrid/Col';
import Row from '../VXGrid/Row';
import './ErrorComponent.less';

const LOCALE_PREFIX = 'components/ErrorComponent/ErrorComponent';
const INLINE_ERRORS = [401, 404, 503];
const ADDITIONAL_ERROR_INFO = [ERROR.TYPE.PP_ACCOUNT, ERROR.TYPE.WIRED_OFF];

export class ErrorComponent extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        actor: PropTypes.oneOf(Object.values(ACTOR)),
        country: PropTypes.oneOf(Object.values(COUNTRY)).isRequired,
        errorType: PropTypes.string,
        statusCode: PropTypes.number,
        action: PropTypes.string,
        systemErrorUrl: PropTypes.string,
        merchantName: PropTypes.string,
        isTeslaFlow: PropTypes.bool,
        hideCtaButton: PropTypes.bool,
        Footer: PropTypes.func.isRequired,
        Header: PropTypes.func.isRequired,
        ContentFooter: PropTypes.func
    };

    static defaultProps = {
        hideCtaButton: false
    };

    displayCta(flow, action, systemErrorUrl) {
        // This is exactly the same regexp found in routes/index.js
        const errorFlowUriPattern = new RegExp('/[a-zA-Z]{2}/[a-zA-Z]{2}/errorFlow');

        if (action && // Action must always be present
            (flow === FLOW_TYPE.DIRECT_APP ||
                // System error url is present
                systemErrorUrl ||
                // Or action points to a URL other than errorFlow
                !errorFlowUriPattern.exec(action))) {
            // Display Continue button
            return true;
        }
        return false;
    }

    getLocalePrefix(statusCode, errorType) {
        if (~INLINE_ERRORS.indexOf(statusCode)) {
            return statusCode;
        } else {
            return errorType;
        }
    }

    render() {
        const {
            intl, errorType, // Note: errorType defaults to noSession
            systemErrorUrl, action, isTeslaFlow,
            merchantName, flow, actor, statusCode, hideCtaButton,
            Footer, Header, ContentFooter, country
        } = this.props;
        const prefix = this.getLocalePrefix(statusCode, errorType);

        // TODO: extract/refactor this when fixing the existing i18n issues
        const i18n = (key) => {
            const id = `${LOCALE_PREFIX}.${prefix}_${key}`;
            const result = intl.formatMessage({
                id,
                defaultMessage: LOCALE.PROPERTY_NOT_FOUND
            }, { merchantName });
            return result === LOCALE.PROPERTY_NOT_FOUND ? '' : result;
        };

        const header = i18n('header');
        const description_para1 = i18n('description_para1' + ((merchantName && prefix === ERROR.TYPE.PP_CREDIT) ? '_merchant' : ''));
        const description_para2 = (~ADDITIONAL_ERROR_INFO.indexOf(prefix) || null) && i18n('description_para2');
        let buttonLabel;

        if (flow === FLOW_TYPE.DIRECT_APP && actor === ACTOR.MERCHANT) {
            buttonLabel = i18n('buttonLabelMerchantDA');
        } else {
            buttonLabel = i18n('buttonLabel');
        }
        const errorUri = action || i18n('action');

        const headerContent = <h1 className="alpha">{header}</h1>;
        const descriptionPara1Content = <p>{description_para1}</p>;
        const descriptionPara2Content = <p>{description_para2}</p>;

        const isGBTeslaFlow = isTeslaFlow && (country === COUNTRY.GREAT_BRITAIN);

        let ctaButton;
        if (hideCtaButton) {
            ctaButton = undefined;
        } else if (typeof buttonLabel === 'string' && buttonLabel.length === 0) {
            ctaButton = undefined;
        } else {
            ctaButton = (

                <Row className="buttons">
                    <Col smOffset={2} sm={8} className="buttons-child">
                        <RedirectButton
                            ctaLabel={buttonLabel}
                            actionUri={errorUri}
                            className="errorReturnFlowAction"
                            buttonId="errorContinue"
                        />
                    </Col>
                </Row>
            );
        }

        return (
            <div className="outerWrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="ErrorComponent">
                            {!isTeslaFlow && (
                                <Header singleColumnLayout={true} displayLogout={(flow === FLOW_TYPE.DIRECT_APP)} />
                            )}
                            <section id="error" className={`errorSection errorSection-${errorType}`}>
                                <Row fluid={true} className="container">
                                    <Col xs={12}>
                                        <div className="error-content">
                                            {isGBTeslaFlow && <div className="error-content-icon cw_icon cw_icon-large cw_icon-attention-large" aria-hidden="true" />}
                                            {header && headerContent}
                                            {description_para1 && descriptionPara1Content}
                                            {description_para2 && descriptionPara2Content}
                                        </div>
                                        {this.displayCta(flow, errorUri, systemErrorUrl) && ctaButton}
                                    </Col>
                                </Row>
                            </section>
                        </div>
                        {ContentFooter && <ContentFooter />}
                    </div>
                </div>
                <Footer showCancelUrl={false} />
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    errorType: _.get(state, 'serverData.errorModel.errorType', 'ppCredit'),
    statusCode: _.get(state, 'serverData.errorModel.statusCode', null),
    flow: state.serverData.flow,
    actor: state.serverData.actor,
    action: _.get(state, 'serverData.errorModel.action', ''),
    systemErrorUrl: _.get(state, 'serverData.errorModel.system_error_uri', ''),
    merchantName: state.serverData.merchantName,
    isTeslaFlow: _.get(state, 'serverData.flow') === FLOW_TYPE.TESLA,
    country: _.get(state, 'serverData.country')
});

export default connect(mapStateToProps)(injectIntl(ErrorComponent));
